import React from 'react';

import ChatHistoryContainer from 'presentation/containers/ChatHistoryContainer';
import classnames from 'classnames/bind';
import CompositionContainer from 'presentation/containers/CompositionContainer';
import HeaderContainer from 'presentation/containers/HeaderContainer';
import styles from 'presentation/components/styles/OngoingChat.css';

let cx = classnames.bind(styles);

export default function OngoingChat(props) {
  let ongoingChatClasses = cx(styles.ongoingChat, 'ongoingChat_selector');

  return (
    <div className={ongoingChatClasses} data-aid="gladlyChatOngoingChatPane">
      <HeaderContainer />
      <ChatHistoryContainer />
      <CompositionContainer />
    </div>
  );
}
